export default __webpack_public_path__ + "static/media/video.b9215dbf.mp4";